import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import styles from './AuthIcons.module.scss';
const AuthIcons = () => {
    // const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID as string;
    // const discordId = process.env.REACT_APP_DISCORD_CLIENT_ID as string;
    // useMount(() => {
    //     const initClient = () => {
    //         gapi.client.init({
    //             clientId: clientId,
    //             scope: 'profile email'
    //         });
    //     };
    //     gapi.load('client:auth2', initClient);
    // });
    // const onSuccess = async (googleData: GoogleLoginResponse | GoogleLoginResponseOffline) => {
    //     if ('tokenId' in googleData)
    //         dispatch(googleLogin(googleData.tokenId))
    // };
    return (_jsx(_Fragment, { children: _jsx("div", Object.assign({ className: cn('d-flex align-items-center justify-content-center', styles.element) }, { children: _jsx(_Fragment, {}) })) }));
};
export default AuthIcons;
